import _ from "lodash";
import {
  getRequest,
  postRequest,
  patchRequest,
  deleteRequest,
  uploadEncodedFile,
  deleteEncodedFile,
} from "NetworkCall";
import { BASE_IMAGES_URL, INSTANCE_URL, itemCount } from "Constants";
import { randomstring } from "randomstring-js";

export var FETCH_ADVERTISEMENTS = "FETCH_ADVERTISEMENTS";
export var OPEN_ADVT_MODAL = "OPEN_ADVT_MODAL";
export var ADVT_BANNERS = "ADVT_BANNERS";
export var LOAD_EDIT_ADVT_DATA = "LOAD_EDIT_ADVT_DATA";

export function fetchAdvertisements(session, pageCount = 0, callback) {
  var perPage = itemCount;
  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `&limit=${perPage}&offset=${offset}`;
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/advertisement?include_count=true&filter=eventid=${session.eventid}&order=createdon%20DESC${offSetQuery}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: FETCH_ADVERTISEMENTS,
          payload: { data: data.resource, count: data.meta.count },
        });
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
}

export function searchAdvertisements(
  session,
  search = "",
  pageCount = 0,
  callback
) {
  var perPage = itemCount;
  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `&limit=${perPage}&offset=${offset}`;
  var searchQuery = `(advtname like %${search}%)`;
  var filter = encodeURI(`(${searchQuery}) AND (eventid=${session.eventid})`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/advertisement?include_count=true&filter=(${filter})&order=createdon%20DESC${offSetQuery}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: FETCH_ADVERTISEMENTS,
          payload: { data: data.resource, count: data.meta.count },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}

export function openAdvtModal(obj) {
  return { type: OPEN_ADVT_MODAL, payload: obj };
}

export function advtBanners(obj) {
  return (dispatch) => {
    dispatch({ type: ADVT_BANNERS, payload: obj });
  };
}

export function insertAdvt(session, values, advt, callback) {
  // debugger;
  eventid = session.eventid;
  var eventid = session.eventid;
  values = { ...values, eventid };
  let bannerImg = values.bannerimg ? values.bannerimg : "";
  var filename = `eventify/${eventid}/advertisement/${
    values.screen
  }_${randomstring(32)}.jpg`;

  return (dispatch) => {
    _uploadImage(session, bannerImg, filename, dispatch, (img) => {
      if (img.success) {
        values = {
          ...values,
          ...(img.data && img.data.path
            ? {
                bannerimg: img.data.path,
              }
            : {}),
        };

        dispatch(_createUpdateAdvt(session, values, advt, callback));
      } else {
        callback({ error: 2 });
      }
    });
  };
}

export function _createUpdateAdvt(session, values, advt, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/advertisement`;

  var dataJson = {};
  if (advt.advtid) {
    dataJson = {
      resource: [{ ...values, advtid: advt.advtid, eventid: session.eventid }],
    };
  } else {
    dataJson = { resource: [values] };
  }

  return (dispatch) => {
    var successCallback = (data) => {
      var returnData = { error: 0, data: data };
      callback(returnData);
    };

    var errorCallback = (error) => {
      var returnData = { error: 1, data: error };
      callback(returnData);
    };

    if (advt.advtid) {
      patchRequest(
        url,
        dataJson,
        session,
        dispatch,
        successCallback,
        errorCallback
      );
    } else {
      postRequest(
        url,
        dataJson,
        session,
        dispatch,
        successCallback,
        errorCallback
      );
    }
  };
}

export function _uploadImage(session, imagedata, filename, dispatch, callback) {
  if (imagedata.search(";base64,") > 0) {
    imagedata = imagedata.replace(/^data:image\/[a-z]+;base64,/, "");
    var imageJson = {
      resource: [
        {
          name: filename,
          type: "file",
          is_base64: true,
          content: imagedata,
        },
      ],
    };

    uploadEncodedFile(
      `${BASE_IMAGES_URL}?check_exist=false`,
      session,
      imageJson,
      dispatch,
      (data) => {
        callback({ success: 1, data: data });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  } else {
    callback({ success: 1 });
  }
}

export function loadAdvtData(data) {
  return {
    type: LOAD_EDIT_ADVT_DATA,
    payload: data,
  };
}

export function deleteAdvertisement(session, advtid, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/advertisement/${advtid}`;
  return (dispatch) => {
    deleteRequest(
      url,
      session,
      dispatch,
      (data) => {
        callback({ error: 0 });
      },
      (error) => {
        callback({ error: 1, data: error });
      }
    );
  };
}
